import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function Label({ customLabel, id, isStepsMode, max, value }) {
    const roundedVal = Math.floor(value);
    return (_jsx("label", Object.assign({ htmlFor: id }, { children: customLabel !== null && customLabel !== void 0 ? customLabel : (_jsx("span", Object.assign({ "aria-hidden": "true" }, { children: isStepsMode
                ? `${roundedVal} / ${max}`
                : `${Math.floor((roundedVal / max) * 100)}%` }))) })));
}
export default Label;
